module.exports = __webpack_public_path__ + "a3d8549a451f9ac23fd5781565fdf8c3.svg";